
const API_URL = process.env.NODE_ENV == 'production' ? window.__ENV__.API_URL : 'http://localhost:5000/api'

module.exports = {
    API_URL: API_URL
}